"use strict";

(function () {
  'use strict';

  angular.module('lr.Auth', ['lr.User']).config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('authInterceptor');
  }]);
})();